import { render, staticRenderFns } from "./EditTrade.vue?vue&type=template&id=48e2ec4e&scoped=true"
import script from "./EditTrade.vue?vue&type=script&lang=js"
export * from "./EditTrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e2ec4e",
  null
  
)

export default component.exports